import { writable } from 'svelte/store';
import { donBaseURL, donClientID, donClientSecret, redirectURL } from './values';
export let mastodonAccessToken = writable(null);
export let mastodonUser = writable(null);
const localStorageCachedAccessToken = localStorage.getItem('mastodonAccessToken');
if (localStorageCachedAccessToken) {
    mastodonAccessToken.set(localStorageCachedAccessToken);
}
export async function fetchAccessToken(code) {
    const res = await fetch(`${donBaseURL}/oauth/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            grant_type: 'authorization_code',
            client_id: donClientID,
            client_secret: donClientSecret,
            redirect_uri: redirectURL,
            code
        })
    });
    const body = await res.json();
    if (body.error) {
        throw new Error(`${body.error}: ${body.error_description}`);
    }
    mastodonAccessToken.set(body.access_token);
    localStorage.setItem('mastodonAccessToken', body.access_token);
}
export async function fetchMastodonUser(token) {
    const res = await fetch(`${donBaseURL}/api/v1/accounts/verify_credentials`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (res.status === 200) {
        const user = await res.json();
        return user;
    }
    const body = await res.json();
    throw new Error(body.error);
}
mastodonAccessToken.subscribe(async (v) => {
    mastodonUser.set(await fetchMastodonUser(v));
});
